import { render } from "./AudioRatingActive2.vue?vue&type=template&id=403e2a65&ts=true"
import script from "./AudioRatingActive2.vue?vue&type=script&lang=ts"
export * from "./AudioRatingActive2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__